<div class="custom-typeahead" (clickOutside)="close()" appClickOutside>
  <input class="form-control box-shadow"
    [ngClass]="{ 'has-error' : bagLocationAddress.invalid && bagLocationAddress.dirty || errorNoPostcode || errorPostcodeNotServiced || errorPostcodeNotEntered}"
    id="BagLocationAddress" name="BagLocationAddress" type="text" enableError="enableError"
    #bagLocationAddress="ngModel" [(ngModel)]="locationItem" (ngModelChange)="valueChange($event)"
    (keydown)="updateSelection($event)" autocomplete="off" required appCheckEmpty>
  <label class="control-label" for="BagLocationAddress">{{ placeholder }}</label>
  <a *ngIf="!showLoader && locationItem.length > 2" class="control-btn" (click)="clearInput()"
    href="javascript:void(0)">
    <i class="icon">cross</i>
  </a>

  <div *ngIf="!showLoader && locationItem.length < 2" class="control-btn">
    <i class="icon">search</i>
  </div>

  <div class="loader-container-typeahead" *ngIf="showLoader">
    <div class="loader loader--gray">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div>
  </div>
  <!-- saved addresses start -->
  <div *ngIf="userAddresses.length > 0 && locationItem.length === 0" class="items items--saved fadeIn">


    <p class="items--saved__title text-caption">{{ recentAddressLabel }}</p>
    <div class="items-wrapper">
      <div class="item" *ngFor="let item of userAddresses; let i = index" (click)="handleSavedSelection(item)">

        <p><strong>{{ item.addressLine1 }}, {{ item.addressLine2 }}</strong></p>
        <p class="text-caption-large">{{ item.addressTown }}, {{ item.addressPostCode }}</p>
      </div>
    </div>
    <a href="javascript:void(0)" class="link" (click)="handleManualInput()">{{ manuallyAddressLabel }}</a>
  </div>
  <!-- saved addresses end -->
  <!-- predictions start -->
  <div *ngIf="items.length > 0 && !selected" class="items fadeIn">
    <div #container class="items-wrapper">
      <div (click)="container.scrollTo(0,0)" class="item" *ngFor="let item of items; let i = index"
        (click)="handleSelection(item)" [ngClass]="{active:isCurrent(i)}" (mouseenter)="setCurrent(i)">

        <a href="javascript:void(0)" class='title'
          [ngClass]="{'address--street':item.Type === 'Street' || item.Type === 'Postcode' || item.Type === 'BuildingNumber' || item.Type === 'BuildingName'}">{{
          item.Text + ' ' + item.Description }}
          <div
            *ngIf="item.Type === 'Street' || item.Type === 'Postcode' || item.Type === 'BuildingNumber' || item.Type === 'BuildingName'">
            <span>{{ moreAddressLabel }}</span>
            <i class="icon">chevron_right</i>
          </div>
        </a>

      </div>
    </div>
  </div>
  <!-- predictions end -->
  <p class="help-block text-danger" *ngIf="bagLocationAddress.invalid && bagLocationAddress.dirty || errorNoPostcode">
    {{ errorTextAddLine }}</p>
  <p class="help-block text-danger" *ngIf="errorPostcodeNotServiced">{{ errorTextOutOfCoverageArea }}</p>
  <p class="help-block text-danger" *ngIf="errorPostcodeNotEntered">{{ errorTextPostCodeIsMissing }}</p>
</div>